import $ from 'jquery';
import headerCartRefresh from './headerCartRefresh';


export default function initAjaxCart() {

	setTimeout(function() {
		$('#crossselling-products').find('form').on('submit', function() {
			var href = $(this).attr('action');
			href += '&ajaxeshop=1';
			var isFancyboxSurelyClosed = false;
			$.fancybox.close();

			$.ajax({url: href}).done(function(response) {
				var openFancybox = function() {
					var $fancybox = $.fancybox.open( response, {
						btnTpl: {
							smallBtn: '<button data-fancybox-close class="fancybox-close-small" title="{{CLOSE}}"><svg version="1.1" id="Vrstva_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 15 15" style="enable-background:new 0 0 15 15;" xml:space="preserve"><path class="st0" fill="#576371" d="M9.6,7.5l4.9-4.9c0.4-0.4,0.4-1,0-1.4l-0.6-0.6c-0.4-0.4-1-0.4-1.4,0L7.5,5.4L2.6,0.5c-0.4-0.4-1-0.4-1.4,0 L0.5,1.1c-0.4,0.4-0.4,1,0,1.4l4.9,4.9l-4.9,4.9c-0.4,0.4-0.4,1,0,1.4l0.6,0.6c0.4,0.4,1,0.4,1.4,0l4.9-4.9l4.9,4.9 c0.4,0.4,1,0.4,1.4,0l0.6-0.6c0.4-0.4,0.4-1,0-1.4L9.6,7.5z"/></svg></button>',
						},
						touch: false,
					});
					$fancybox.current.$content.trigger('contentload');
					headerCartRefresh();		
					initAjaxCart();			
				};
				if (isFancyboxSurelyClosed) {
					openFancybox();
				} else {
					setTimeout(function() {
						openFancybox();
					}, 500);					
				}
			})

			setTimeout(function() {
				isFancyboxSurelyClosed = true;
			}, 500);

			return false;
		})					
	}, 100);	

}